import { call, put, takeLatest } from 'redux-saga/effects';
import { Types, Creators } from './duck';
import { sendNotification } from './api';
import { safeResolveAsync } from '../../utils';
import { OK } from 'http-status-codes';

// Worker Saga
// function* sendNotificationSaga({data}) {
//   try {

//     yield put(Creators.sendNotificationRequest());
//     const response = yield call(sendNotification, data);
//     yield put(Creators.sendNotificationSuccess(response));
//   } catch (error) {
//     yield put(Creators.sendNotificationFailure(error.message));
//   }
// }

// function* sendNotificationSaga({ data, resolve }) {
//   try {
//     yield put(Creators.sendNotificationRequest());

//     const response = yield call(
//       sendNotification,
//       data
//     );
//     if (response.status === OK) {
//       yield put(
//         Creators.sendNotificationSuccess(
//           response.data
//         )
//       );

//       yield safeResolveAsync(resolve, {
//         success: true,
//         data: response.data,
//       });
//     } else {
//       const errorMessage =
//         response.statusText ||
//         'Failed to send notification';

//       yield put(
//         Creators.sendNotificationFailure(
//           errorMessage
//         )
//       );

//       yield safeResolveAsync(resolve, {
//         success: false,
//         error: errorMessage,
//       });
//     }
//   } catch (err) {
//     const errorMessage =
//       (
//         err &&
//         err.response &&
//         err.response.data &&
//         err.response.data.error
//       ) ||
//       (err && err.message) ||
//       'Failed to send notification';

//     yield put(
//       Creators.sendNotificationFailure(
//         errorMessage
//       )
//     );

//     yield safeResolveAsync(resolve, {
//       success: false,
//       error: errorMessage,
//     });
//   }

//   yield safeResolveAsync(resolve, {
//     success: false,
//     error: errorMessage,
//   });
// }

function* sendNotificationSaga({ data, resolve }) {
  try {
    yield put(Creators.sendNotificationRequest());

    const response = yield call(sendNotification, data);

    if (response.status === OK) {
      yield put(Creators.sendNotificationSuccess(response.data));

      yield safeResolveAsync(resolve, {
        success: true,
        data: response.data,
      });
    } else {
      const errorMessage =
        response.statusText || 'Failed to send notification';

      yield put(Creators.sendNotificationFailure(errorMessage));

      yield safeResolveAsync(resolve, {
        success: false,
        error: errorMessage,
      });
    }

  } catch (err) {
    let errorMessage = 'Failed to send notification';

    if (err && err.response && err.response.data && err.response.data.error) {
      errorMessage = err.response.data.error;
    } else if (err && err.message) {
      errorMessage = err.message;
    }

    yield put(Creators.sendNotificationFailure(errorMessage));

    yield safeResolveAsync(resolve, {
      success: false,
      error: errorMessage,
    });
  }
}
// Watcher Saga
export default function* notificationSaga() {
  yield takeLatest(Types.SEND_NOTIFICATION, sendNotificationSaga);
}